module.exports = __webpack_public_path__ + "img/661fcdd.svg";